import { gql } from '@apollo/client'

export const GET_SHOP_SETTINGS = gql`
  fragment CoreShopSettingsData on ShopSetting {
    id
    createdAt
    updatedAt
    currency
    currency_symbol
    show_user_details_in_blog
    uuid_name_space
    enable_vat
    current_prices_with_vat
    vat_percentage
    invoice_serial_number_letters
    default_dispatch_information {
      id
      createdAt
      updatedAt
      manufacturing_time
      shipping_time
      __typename
    }
    default_manufacturer {
      id
      createdAt
      updatedAt
      is_manufacturer_public
      company_name
      company_address
      company_code
      vat_code
      company_email
      company_phone
      country
      country_code
      website
      bank_name
      bank_account_number
      bic_swift
      logo_image {
        id
        src
        __typename
      }
      manufacturer_profiles {
        id
        name
        description
        language
        meta_information {
          id
          permalink
          meta_title
          meta_description
          __typename
        }
        __typename
      }
      __typename
    }
    default_payment_method {
      id
      __typename
    }
    default_shipping_method {
      id
    }
    default_meta_image {
      id
      src
    }
    shop_profiles {
      id
      name
      description
      language
      meta_information {
        id
        permalink
        meta_title
        meta_description
        __typename
      }
      __typename
    }
    facebook
    twitter
    instagram
    pinterest
    linkedin
    automatic_product_translate
    product_position_script_on_save
    automatic_image_generation
    enabled_languages {
      id
      createdAt
      updatedAt
      language
      web_address_enabled
      web_address
      google_analytics
      google_tag_manager
      facebook_pixel
      facebook_page_id
      hotjar
      enable_language_switcher
      price_multiplier
      shop_phone_number
      default_language
      __typename
    }
    footer_logo_image {
      src
      __typename
    }
    footer_copyright_text
    revalidate_enabled
    revalidate_low_priority_links
    __typename
  }

  query GET_SHOP_SETTINGS {
    findFirstShopSetting {
      ...CoreShopSettingsData
      __typename
    }
  }
`

export const UPDATE_SHOP_SETTINGS_V2 = gql`
  mutation updateShopSettingsV2(
    $shopSettingsId: Int
    $default_meta_image: [String]
    $enable_vat: Boolean
    $current_prices_with_vat: Boolean
    $vat_percentage: Int
    $invoice_serial_number_letters: String
    $default_payment_method: Int
    $default_shipping_method: Int
    $show_user_details_in_blog: Boolean
    $facebook: String
    $twitter: String
    $instagram: String
    $pinterest: String
    $linkedin: String
    $currency: Currency
    $automatic_product_translate: Boolean
    $product_position_script_on_save: Boolean
    $automatic_image_generation: Boolean
    $enabled_languages: [EnabledLanguageUncheckedCreateInput!]
    $footer_logo_image: [String]
    $footer_copyright_text: String
    $revalidate_enabled: Boolean
    $revalidate_low_priority_links: Boolean
  ) {
    updateShopSettingsV2(
      shopSettingsId: $shopSettingsId
      default_meta_image: $default_meta_image
      enable_vat: $enable_vat
      current_prices_with_vat: $current_prices_with_vat
      vat_percentage: $vat_percentage
      invoice_serial_number_letters: $invoice_serial_number_letters
      default_payment_method: $default_payment_method
      default_shipping_method: $default_shipping_method
      show_user_details_in_blog: $show_user_details_in_blog
      facebook: $facebook
      twitter: $twitter
      instagram: $instagram
      pinterest: $pinterest
      linkedin: $linkedin
      currency: $currency
      automatic_product_translate: $automatic_product_translate
      product_position_script_on_save: $product_position_script_on_save
      automatic_image_generation: $automatic_image_generation
      enabled_languages: $enabled_languages
      footer_logo_image: $footer_logo_image
      footer_copyright_text: $footer_copyright_text
      revalidate_enabled: $revalidate_enabled
      revalidate_low_priority_links: $revalidate_low_priority_links
    ) {
      id
      enabled_languages {
        id
        language
        web_address_enabled
        web_address
        google_analytics
        google_tag_manager
        facebook_pixel
        facebook_page_id
        hotjar
        enable_language_switcher
        price_multiplier
        shop_phone_number
        default_language
        __typename
      }
      __typename
    }
  }
`
